<script setup>
import { ref } from 'vue'

// Vars
const searchText = ref('')
</script>

<template>
    <v-text-field v-model="searchText" v-bind="$attrs" clearable></v-text-field>
</template>

<style scoped></style>
